import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useAppUserProducts } from '../providers/AppProductProvider';
import { useAppUser } from 'App/components/utils/providers/AppUserProvider';
import { isEmptyArray } from 'types';
import { useTranslation } from 'react-i18next';
import { MenuItem } from 'App/menu-items';

/**
 * The page a menu item lands on inside this app; microfrontend items, also inside a group, need a full page load.
 */
const landingItem = ( item: MenuItem ): MenuItem | undefined => {
  if ( item.nestedApplication ) {
    return undefined;
  }
  return item.children ? item.children.find( ( child ) => !child.nestedApplication ) : item;
};

/**
 * This Component calculates landing page and redirect to it.
 * Landing page depends on menu items fetched from user products.
 * This component goal is to redirect to langing page.
 * This component renders nothing.
 */
export const LandingPageResolver: React.FC = () => {
  const { t } = useTranslation( [ 'base' ] );
  const userProducts = useAppUserProducts();
  const currentUser = useAppUser();
  const history = useHistory();
  const { url } = useRouteMatch();
  const landingPage = React.useMemo( () => {
    const firstMenuItem = userProducts
      .map( ( product ) => product.menuItems.map( landingItem ).find( Boolean ) )
      .find( Boolean );
    const prefix = url.replace( /\/+\s*$/, '' );

    if ( !firstMenuItem || isEmptyArray( currentUser.userPermissions ) ) {
      return '';
    }

    const path = firstMenuItem.url!.replace( /^\/+/, '' );
    return prefix + '/' + path;
  }, [ currentUser, url, userProducts ] );

  React.useEffect( () => {
    if ( !landingPage ) {
      const prefix = url.replace( /\/+\s*$/, '' );
      history.replace( prefix + '/noaccess', { messageKey: 'noAccessUser' } );
      return;
    }

    history.replace( landingPage );
  }, [ history, landingPage, t, url ] );

  return (
    <React.Fragment />
  );
};
